import { ClickAwayListener, Popper } from "@mui/material";
import React from "react";


const DropdownCellOptions: React.FC<DropdownCellOptionsProps> = (props: DropdownCellOptionsProps) => {
  const { focusing, onChangeAnchor, anchorEl, onExtraAction, onHover, children } = props;


  return (
    <ClickAwayListener onClickAway={() => {!focusing && onChangeAnchor(null); onExtraAction && onExtraAction(false)}}>
      <Popper
        anchorEl={anchorEl}
        open={anchorEl !== null}
        disablePortal={true}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
          zIndex: 1
        }}
      >
        <div onMouseOver={() => onHover(true)} onMouseOut={() => onHover(false)}>
          {children}
        </div>
      </Popper>
    </ClickAwayListener>
  )
}

export default DropdownCellOptions;

export type DropdownCellOptionsProps = {
  focusing: boolean;
  onChangeAnchor: (val: null | HTMLElement) => void;
  anchorEl: null | HTMLElement;
  onExtraAction?: (val: boolean) => void;
  onHover: (val: boolean) => void;
  children: any
}

